import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { MainButton, PinkNotification } from "../../";
import { BoardContext } from "../../../../context";
import ProgressBar from "../../Display/ProgressBar/ProgressBar";

let instructionNumber: number = 0;

const NextButton: FC<{}> = () => {
    const { setInstructionTutorial, instructionTutorial} = useContext(BoardContext);
    const instructions: string[] = ["", "leftSideOfTheScreen", "rightSideOfTheScreen", ""];
    const { t } = useTranslation();
    
    const goToTheNextInButtonstruction = () => {
        instructionNumber = instructionNumber + 1;
        setInstructionTutorial(instructions[instructionNumber]);
    }

	return (
		<div className="full_screen_vw_vh" style={{position: "absolute", zIndex: 51}}>
            <ProgressBar totalProgress = {10} progressNumber = {instructionNumber + 1} ></ProgressBar>
            {instructionTutorial === "solutionCards" && <div style={{position: "absolute", height: "100%", width: "100%", display: "flex", top: "280px", justifyContent: "center"}}> 
                <div className="notification_scale_cards_in_hands" style={{position: "absolute",  transform: "scale(1.5)", zIndex: 19, width: "500px"}} >
                    <PinkNotification notificationWidthVW={30} notificationRenderingSide="top" text={t("tipTheseAreYourSolutionCardsText")} moveFromTop={-100} isStatic={true} />
                </div>
            </div>}
            <div style={{position: "absolute", bottom: "3vh", right: "50px", width: "200px", height: "50px", display: "flex", alignItems: "end"}}> 
                <MainButton text={t("nextText")} type="big" clickHandler={() => goToTheNextInButtonstruction()}  /> 
            </div>
        </div>
	);
};

export default NextButton;

